<div [ngClass]="getLevelClass()">
  <ng-container>
    <div class="verify-email-container">
      <div class="entry-field input-label-container" [ngClass]="{ 'entry-field--disabled': shouldLock || isDisabled }">
        <basic-label overrideDisplayText="Email" *ngIf="!noLabel"></basic-label>
        <input
          *ngIf="!isServer; else ssr"
          type="text"
          class="entry-field__input"
          [class.entry-field--error__input]="errorMessage[prop]"
          [disabled]="shouldLock || isDisabled"
          [(ngModel)]="ownerEmail"
          (change)="saveOwnerEmail()"
          (blur)="handleBlur()"
          (ngModelChange)="clearErrors()"
        />
        <ng-template #ssr>
          <div class="entry-field__input">{{ ownerEmail }}</div>
        </ng-template>
        <p class="error-message error-message--entry-field">{{ errorMessage[prop] }}</p>
      </div>
      <div class="entry-field__email-suffix" *ngIf="isDisabled !== true && shouldLock">
        <basic-tooltip position="above" [allowAutoOrientation]="true">
          <div label>
            <!-- The way this component is being used we can't use cp-icon. Need to figure out a way to work around that. -->
            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.99999 11.6667C7.36818 11.6667 7.66666 11.3682 7.66666 11C7.66666 10.6318 7.36818 10.3333 6.99999 10.3333C6.63181 10.3333 6.33333 10.6318 6.33333 11C6.33333 11.3682 6.63181 11.6667 6.99999 11.6667Z"
                stroke="#858187"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M7 11.6667V13.6667" stroke="#858187" stroke-linecap="round" stroke-linejoin="round" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.33333 8.33333C1.33333 7.78105 1.78104 7.33334 2.33333 7.33334H11.6667C12.2189 7.33334 12.6667 7.78105 12.6667 8.33334V15.6667C12.6667 16.219 12.2189 16.6667 11.6667 16.6667H2.33333C1.78104 16.6667 1.33333 16.219 1.33333 15.6667V8.33333Z"
                stroke="#858187"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.33333 5C3.33333 2.97495 4.97495 1.33333 7 1.33333C9.02504 1.33333 10.6667 2.97495 10.6667 5V7.33333H3.33333V5Z"
                stroke="#858187"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div tip>
            <p>You cannot change an existing client’s email address.</p>
            <br />
            <p>The client can change the email address when they log into Coverpath.</p>
          </div>
        </basic-tooltip>
      </div>
    </div>
  </ng-container>
</div>
